export default __webpack_public_path__ + "static/media/no data.7ff31ff4.svg";